module.exports = __webpack_public_path__ + "img/img-yd-app.7f43d27.svg";